module.exports = __webpack_public_path__ + "img/file-search-empty.90b31185.png";